import { render, staticRenderFns } from "./FormularioError.vue?vue&type=template&id=132e724c&"
import script from "./FormularioError.vue?vue&type=script&lang=js&"
export * from "./FormularioError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports